import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export function CancelPreviousRequest(): MethodDecorator {
    const subject = new Subject<void>();
    return function (target: Function, key: string, descriptor: PropertyDescriptor) {
        const originalMethod = descriptor.value;
        descriptor.value = function (...args: any[]) {
            subject.next();
            return originalMethod.apply(this, args)
                .pipe(takeUntil(subject));
        };
        return descriptor;
    };
}
